import { connect } from 'react-redux';

import { type AppState } from '../../reducer';
import { type Settings } from '../../settings';
import { PricingCalculator } from '../components';

type StateProps = Readonly<{
  settings: Settings;
}>;

type OwnProps = {};

type DispatchProps = void;

const mapStateToProps = (state: AppState) => ({
  settings: state.settings,
});

export const PricingCalculatorContainer = connect<StateProps, DispatchProps, OwnProps, AppState>(mapStateToProps)(
  PricingCalculator,
);
